import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { SignatureDrawerDirective } from './signature-drawer.directive';

@NgModule({
  declarations: [SignatureDrawerDirective],
  imports: [CommonModule],
  exports: [SignatureDrawerDirective],
})
export class SignaturePadModule {}
